import CryptoJS from 'crypto-js';

class AESEncryption {
    constructor(salt, iv) {
        const salt_enc = CryptoJS.enc.Utf8.parse(salt);
        const iv_enc = CryptoJS.enc.Utf8.parse(iv);

        this._salt = salt_enc;
        this._iv = iv_enc;
    }

    encrypt(value) {
        let encrypted = CryptoJS.AES.encrypt(value,
            this._salt,
            {
                iv: this._iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }
        );

        return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    }

    decrypt(value) {
        if (value !== null) {
            let decrypted = CryptoJS.AES.decrypt(value, this._salt,
                {
                    iv: this._iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                }
            );
            return decrypted.toString(CryptoJS.enc.Utf8);
        }
        return null;
    }
}

export default new AESEncryption(
    process.env.VUE_APP_TOKEN_STORAGE_SECRET,
    process.env.VUE_APP_TOKEN_STORAGE_SECRET_IV
);